import type { SchoolsFeedbackSubmission } from '~/types/Schools/SchoolsFeedback';

import { EVENTS } from '~/constants/events';

import { useSchoolsFeedback } from './usePlatformFeedback';

export const useSchoolsFeedbackModal = () => {
  const { t } = useI18n();
  const analytics = useAnalyticsService();
  const { show: showToast } = useToast();
  const { currentSchoolId, personalTeacherRole } = useAuth();
  const { submitSchoolsFeedback, submitting } = useSchoolsFeedback();

  const isOpen = ref(false);

  const openFeedback = () => {
    analytics.track(EVENTS.SCHOOLS_FEEDBACK_CLICKED, {
      schoolId: currentSchoolId.value,
      roleId: personalTeacherRole.value?.id,
    });
    isOpen.value = true;
  };

  const submitFeedback = async (submission: SchoolsFeedbackSubmission) => {
    const result = await submitSchoolsFeedback(submission);

    if (!result) {
      showToast({ variant: 'error', message: t('unified.errors.genericFailed') });
      return;
    }

    isOpen.value = false;
    showToast({ variant: 'success', message: t('schools.feedback.submittedToast') });
  };

  return { isOpen, submitting, openFeedback, submitFeedback };
};
